import React from 'react';
import {
  columnName,
  columnEmail,
  columnNameLink,
  columnRole,
  columnRoleLink,
  columnRoleLinkNoFilter,
  hasColumn,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';

const SubscribersTableColumns = ({
  columns = [
    columnName,
    columnNameLink,
    columnEmail,
    columnRole,
    columnRoleLinkNoFilter,
  ],
}) => (
  <NameDescriptionColumns columns={columns} entity="user">
    {hasColumn(columns, columnEmail) && (<UnsortedColumn columnId={columnEmail} />)}
    {hasColumn(columns, [columnRole, columnRoleLink, columnRoleLinkNoFilter]) && (
    <UnsortedColumn columnId={columnRole} />
    )}
  </NameDescriptionColumns>
);

export default SubscribersTableColumns;
